import { IS_DEV } from '../lib/env';
import { isNetworkError } from '../services/api';

interface Props {
  error?: unknown;
  resetError?: () => void;
}

const OFFLINE_COPY = {
  title: 'Sin conexión con el servidor',
  description:
    'No pudimos contactar el servidor. Revisa tu conexión e intenta de nuevo en unos momentos.',
};

const GENERIC_COPY = {
  title: 'Algo salió mal',
  description:
    'Ocurrió un error inesperado en la aplicación. Puedes intentar recargar la vista o volver al inicio.',
};

export default function ErrorFallback({ error, resetError }: Props) {
  const errorMessage = error instanceof Error ? error.message : undefined;
  const copy = isNetworkError(error) ? OFFLINE_COPY : GENERIC_COPY;

  return (
    <div className="min-h-screen bg-parchment flex items-center justify-center px-6">
      <div className="bg-surface border border-border-emphasis rounded-md p-8 max-w-lg w-full text-ink">
        <h1 className="text-[1.5rem] font-serif mb-2">{copy.title}</h1>
        <p className="text-ink-secondary text-[0.875rem] mb-6">{copy.description}</p>

        {IS_DEV && errorMessage && (
          <pre className="text-[0.75rem] text-destructive bg-surface-inset p-3 rounded-sm font-mono overflow-auto mb-6">
            {errorMessage}
          </pre>
        )}

        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={() => {
              window.location.href = '/';
            }}
            className="bg-accent text-ink-inverse hover:bg-accent-hover px-4 py-2 rounded-sm text-[0.875rem]"
          >
            Volver al inicio
          </button>

          {resetError && (
            <button
              type="button"
              onClick={resetError}
              className="border border-border-emphasis text-ink-secondary bg-transparent hover:text-ink hover:border-border-strong px-4 py-2 rounded-sm text-[0.875rem]"
            >
              Reintentar
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
